import styled from 'styled-components';

export const Mark = styled.mark`
  && {
    background-color: ${({theme}) => theme.color.textHighlight};
  }
`;
